class ModuleProvider {
	modules = [];
	context = {};

	register(module) {
		this.modules.push(module);
	}

	getModules() {
		return this.modules;
	}
}

export default ModuleProvider;
